/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Weclapp_QuotationInputs */



/**
* | output |
* | --- |
* | "Create a weclapp quotation" |
*
* @param {Agent_Result_Action_Weclapp_QuotationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_weclapp_quotation = /** @type {((inputs?: Agent_Result_Action_Weclapp_QuotationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Weclapp_QuotationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("weclapp-Angebot erstellen")
	return /** @type {LocalizedString} */ ("Create a weclapp quotation")
});